import "./help.css"
function Help() {
  return (
    <>
      <div className="helpcenter  ">

        {/* Header */}
        <div className="card shadow-sm mb-4">
          <div className="card-body text-center">
            <h3 className="fw-bold">Help Center</h3>
            <p className="text-muted">
              How can we help you today?
            </p>

            <div className="row justify-content-center">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search for help..."
                />
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="card shadow-sm mb-4">
          <div className="card-header fw-bold">
            Frequently Asked Questions
          </div>

          <div className="card-body">

            <div className="mb-3">
              <h6 className="fw-semibold">
                How do I create a new project?
              </h6>
              <p className="small">
                Go to dashboard → Click "Create Project" → Fill required fields → Save.
              </p>
            </div>

            <div className="mb-3">
              <h6 className="fw-semibold">
                How can I assign team members?
              </h6>
              <p className="small">
                Open the project → Navigate to Assigned section → Select member.
              </p>
            </div>

            <div>
              <h6 className="fw-semibold">
                How do I track progress?
              </h6>
              <p className="small">
                Use Target and Completed sections to monitor progress.
              </p>
            </div>

          </div>
        </div>

        {/* Submit Ticket */}
        <div className="card shadow-sm mb-4">
          <div className="card-header fw-bold">
            Submit a Support Ticket
          </div>

          <div className="card-body">
            <div className="row g-4">

              <div className="col-md-6">
                <label className="form-label">Subject</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter subject"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Priority</label>
                <select className="form-select">
                  <option>Low</option>
                  <option>Medium</option>
                  <option>High</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Describe your issue..."
                ></textarea>
              </div>

              <div className="col-12 text-end">
                <button className="btn btn-primary">
                  Submit Ticket
                </button>
              </div>

            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="card shadow-sm">
          <div className="card-header fw-bold">
            Contact Support
          </div>

          <div className="card-body">
            <p><strong>Email:</strong> support@company.com</p>
            <p><strong>Phone:</strong> +20 123 456 7890</p>
            <p><strong>Working Hours:</strong> 9 AM - 5 PM</p>
          </div>
        </div>

      </div>
    </>
  );
}

export default Help;